import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " ID ", -1)
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "mb-0 pl-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, " PRO ", -1)
const _hoisted_12 = { class: "d-flex align-items-center gap-2" }
const _hoisted_13 = {
  key: 0,
  class: "mb-0 pl-2"
}
const _hoisted_14 = {
  key: 0,
  class: "badge badge-warning",
  style: {"color":"#333"}
}
const _hoisted_15 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_16 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "w-250px" }
const _hoisted_20 = { class: "paragraph" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_23 = { class: "h4 mb-8" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "paragraph" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Цена: ", -1)
const _hoisted_29 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Категория: ", -1)
const _hoisted_31 = { class: "paragraph" }
const _hoisted_32 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Местоположение: ", -1)
const _hoisted_34 = { class: "paragraph" }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", { class: "text-danger" }, "Местоположение не указано", -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 3,
  class: "mb-10"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Страна происхождения: ", -1)
const _hoisted_40 = { class: "paragraph" }
const _hoisted_41 = {
  key: 4,
  class: "mb-8"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Характеристики: ", -1)
const _hoisted_43 = { class: "bordered" }
const _hoisted_44 = { class: "w-200px" }
const _hoisted_45 = { class: "paragraph mx-2" }
const _hoisted_46 = { class: "w-200px" }
const _hoisted_47 = { class: "paragraph mx-2" }
const _hoisted_48 = {
  key: 5,
  class: "mb-8 w-100"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Уточнение заказа: ", -1)
const _hoisted_50 = { class: "bordered w-100" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Тип заказа ")
], -1)
const _hoisted_52 = { class: "w-50" }
const _hoisted_53 = { class: "paragraph mx-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Объем заказа ")
], -1)
const _hoisted_55 = { class: "paragraph mx-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Доставка ")
], -1)
const _hoisted_57 = { class: "paragraph mx-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Aдрec дocтaвки ")
], -1)
const _hoisted_59 = { class: "paragraph mx-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Способ оплаты ")
], -1)
const _hoisted_61 = { class: "paragraph mx-2" }
const _hoisted_62 = {
  key: 6,
  class: "mb-4"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-6" }, " Описание: ", -1)
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "mb-4 w-100" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Объявление: ", -1)
const _hoisted_67 = { class: "w-100 bordered" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Создано: ")
], -1)
const _hoisted_69 = { class: "w-50" }
const _hoisted_70 = { class: "paragraph mx-2" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Обновлено: ")
], -1)
const _hoisted_72 = { class: "" }
const _hoisted_73 = { class: "paragraph mx-2" }
const _hoisted_74 = { class: "mb-4 w-100" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Юзер: ", -1)
const _hoisted_76 = { class: "bordered w-100" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Юзер: ")
], -1)
const _hoisted_78 = { class: "w-50" }
const _hoisted_79 = { class: "paragraph mx-2" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Зарегистрирован: ")
], -1)
const _hoisted_85 = { class: "" }
const _hoisted_86 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Авторизован: ")
], -1)
const _hoisted_88 = { class: "" }
const _hoisted_89 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_90 = {
  class: "",
  style: {"vertical-align":"middle","line-height":"1.2"}
}
const _hoisted_91 = { class: "paragraph mx-2" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Все объявления юзера: ")
const _hoisted_93 = { class: "py-0" }
const _hoisted_94 = { class: "w-100" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Активных: ")
], -1)
const _hoisted_96 = { class: "" }
const _hoisted_97 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Отклонённых: ")
], -1)
const _hoisted_99 = { class: "" }
const _hoisted_100 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = { key: 2 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", null, " Не одобрялся ", -1)
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_114 = { class: "mb-2" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { key: 2 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("p", null, " Не отклонялся ", -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = { class: "mb-2 w-180px" }
const _hoisted_123 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_124 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_125 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("span", null, " Аккаунт ", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("strong", null, " PRO ", -1)
const _hoisted_128 = [
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = { class: "paragraph" }
const _hoisted_130 = { key: 2 }
const _hoisted_131 = {
  key: 3,
  class: "paragraph"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("strong", null, " Зарегистрирован: ", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_134 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", null, " Создано ", -1)
const _hoisted_136 = { class: "paragraph" }
const _hoisted_137 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", null, " Изменено ", -1)
const _hoisted_139 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_140 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_141 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", null, " Цена ", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, [
    /*#__PURE__*/_createTextVNode("Страна"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("происхождения")
  ])
], -1)
const _hoisted_144 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_145 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, [
    /*#__PURE__*/_createTextVNode("Местонахождение"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("товара")
  ])
], -1)
const _hoisted_147 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_148 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_149 = ["onClick"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document-add fs-3" }, null, -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
  title: "Редактировать"
}
const _hoisted_153 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-edit fs-3" }, null, -1)
const _hoisted_154 = ["onClick"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-delete fs-3" }, null, -1)
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = {
  key: 0,
  class: "buttons-wrap"
}
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_159 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_160 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" Активировать премиум ")
const _hoisted_162 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_163 = /*#__PURE__*/_createTextVNode(" Отмена ")
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" Активировать ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_AgroPriceText = _resolveComponent("AgroPriceText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ads_filter = _resolveComponent("ads-filter")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ads_filter, {
        onFilterButtonClick: _ctx.filterButtonClick,
        "items-total": _ctx.newsPaginationItemsNumber,
        "pages-total": _ctx.newsPaginationPagesNumber,
        "current-page": _ctx.filterData.page
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_pre, {
            hide: "",
            title: "requestedNewsList",
            data: _ctx.requestedNewsList
          }, null, 8, ["data"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _ctx.requestedNewsList,
            "scrollbar-always-on": true,
            "table-layout": "fixed",
            "show-header": true,
            resizable: true
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, {
                "image-size": 300,
                description: "Ничего не найдено"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "top",
                class: "py-5 px-0 fw-bolder text-center min-w-50px align-top",
                width: _ctx.calcWidth(40),
                property: "checked"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.requestedNewsList.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedModel) = $event)),
                          class: "form-check-input",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchAllCheckboxes && _ctx.switchAllCheckboxes(...args)))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.checkedModel]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((scope.row.checked) = $event),
                      class: "form-check-input"
                    }, null, 8, _hoisted_5), [
                      [_vModelCheckbox, scope.row.checked]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                property: "id",
                label: "ID",
                width: _ctx.calcWidth(120)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortTheColumn('id')))
                    }, [
                      _hoisted_7,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState.id.dir,
                      'bi-sort-down': !_ctx.sortState.id.dir,
                      'opacity-25':
                        _ctx.currentSort !== 'id' && _ctx.currentSort !== '-id',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x mr-2", {
                      'bi-patch-check-fill text-primary':
                        scope.row.status === 'confirmed',
                      'bi-patch-minus-fill text-danger':
                        scope.row.status === 'rejected',
                      'bi-patch-exclamation-fill text-warning':
                        scope.row.status === 'not_verified',
                    }]),
                        title: _ctx.generateNewsTitle(scope.row.status)
                      }, null, 10, _hoisted_9),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.id), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                label: "PRO",
                width: _ctx.calcWidth(70)
              }, {
                header: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      (scope.row.owner)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                            (scope.row.owner.account_pro)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " PRO "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(160),
                label: "Закреплено до"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.fixed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " FIXED "))
                      : _createCommentVNode("", true),
                    (
                    scope.row.fixed_until && scope.row.fixed_until.length > 0
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.dateConverter(scope.row.fixed_until)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 w-280px align-top",
                width: _ctx.calcWidth(280),
                label: "Фото"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_17, [
                    (scope.row.photos.length > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: 'news_carousel_' + scope.$index
                        }, [
                          _createVNode(_component_vue_easy_lightbox, {
                            scrollDisabled: false,
                            visible: scope.row.lightboxVisible,
                            imgs: scope.row.previewPhotos,
                            index: _ctx.currentImageId,
                            onHide: ($event: any) => (_ctx.closeLightbox(scope.$index))
                          }, null, 8, ["visible", "imgs", "index", "onHide"]),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.photos, (subitem, subindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: subindex,
                                class: _normalizeClass({ active: subindex === 0 })
                              }, [
                                _createVNode(_component_el_image, {
                                  id: `el-image-${subindex}`,
                                  style: {"width":"250px","height":"auto","cursor":"pointer"},
                                  src: subitem.path,
                                  onClick: ($event: any) => {
                          ;[
                            _ctx.toggleLightbox(scope.$index),
                            _ctx.setCurrentImageId(subindex),
                          ]
                        }
                                }, null, 8, ["id", "src", "onClick"])
                              ], 2))
                            }), 128))
                          ])
                        ], 8, _hoisted_18))
                      : (_openBlock(), _createBlock(_component_el_skeleton_item, {
                          key: 1,
                          variant: "image",
                          class: "w-250px h-200px"
                        }))
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-5 align-top",
                width: _ctx.calcWidth(410),
                label: "Название"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["my-2 flex", _ctx.rowClasses])
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", null, [
                        (scope.row.type === 'demand')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Спрос "))
                          : _createCommentVNode("", true),
                        (scope.row.type === 'offer')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Предложение "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("h4", _hoisted_23, [
                      (scope.row.name && scope.row.name.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row.name), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, " Нет названия "))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_AgroPriceText, {
                          modelValue: scope.row.price,
                          measureName: scope.row.measure_name
                        }, null, 8, ["modelValue", "measureName"])
                      ])
                    ]),
                    (
                    scope.row.rubric &&
                      scope.row.rubric.name &&
                      scope.row.rubric.name.length
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("span", _hoisted_31, [
                            _createVNode(_component_router_link, {
                              class: "underline text-success",
                              to: {
                        name: 'ads-list',
                        query: {
                          page: 1,
                          limit: 10,
                          'filter[status]': 'all',
                          'filter[rubric]': scope.row.rubric.id,
                          'filter[active]': 'active',
                        },
                      },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.rubric.fullPath), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.geo_name && scope.row.geo_name.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("span", _hoisted_34, _toDisplayString(scope.row.geo_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.geo_missing)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, _hoisted_37))
                      : _createCommentVNode("", true),
                    (
                    scope.row.country_of_origin &&
                      scope.row.country_of_origin.length
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("span", _hoisted_40, _toDisplayString(scope.row.country_of_origin), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                    scope.row['rubric_props'] &&
                      scope.row['rubric_props'].length
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("table", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row['rubric_props'], (prop, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_44, [
                                  _createElementVNode("p", _hoisted_45, _toDisplayString(prop.title), 1)
                                ]),
                                _createElementVNode("td", _hoisted_46, [
                                  _createElementVNode("p", _hoisted_47, _toDisplayString(prop.value), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row['refine_order'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("table", _hoisted_50, [
                            _createElementVNode("tr", null, [
                              _hoisted_51,
                              _createElementVNode("td", _hoisted_52, [
                                _createElementVNode("p", _hoisted_53, _toDisplayString(scope.row.order['order_type']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_54,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_55, _toDisplayString(scope.row.order['order_quantity']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_56,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_57, _toDisplayString(scope.row.order['order_delivery_type']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_58,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_59, _toDisplayString(scope.row.order['order_delivery_address']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_60,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_61, _toDisplayString(scope.row.order['order_payment_method']), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.description && scope.row.description.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", {
                            class: "paragraph",
                            innerHTML: scope.row.description
                          }, null, 8, _hoisted_64)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("table", _hoisted_67, [
                        _createElementVNode("tr", null, [
                          _hoisted_68,
                          _createElementVNode("td", _hoisted_69, [
                            _createElementVNode("p", _hoisted_70, _toDisplayString(scope.row.created_at), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_71,
                          _createElementVNode("td", _hoisted_72, [
                            _createElementVNode("p", _hoisted_73, _toDisplayString(scope.row.modified_at), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _hoisted_75,
                      _createElementVNode("table", _hoisted_76, [
                        _createElementVNode("tr", null, [
                          _hoisted_77,
                          _createElementVNode("td", _hoisted_78, [
                            _createElementVNode("p", _hoisted_79, [
                              (scope.row.owner && scope.row.owner.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    target: "_blank",
                                    class: "underline text-success",
                                    to: {
                              name: 'users-edit',
                              params: {
                                id: scope.row.owner.id,
                              },
                            }
                                  }, {
                                    default: _withCtx(() => [
                                      (scope.row.owner.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(scope.row.owner.name), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                    (scope.row.owner && scope.row.owner.name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(scope.row.owner.name), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_83, " Нет имени "))
                                  ]))
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_84,
                          _createElementVNode("td", _hoisted_85, [
                            (
                            scope.row.owner && scope.row.owner.registered_at
                          )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(scope.row.owner.registered_at), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_87,
                          _createElementVNode("td", _hoisted_88, [
                            (scope.row.owner && scope.row.owner.last_login)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(scope.row.owner.last_login), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_90, [
                            _createElementVNode("p", _hoisted_91, [
                              (scope.row.owner && scope.row.owner.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "underline text-success",
                                    to: {
                              page: 1,
                              limit: 10,
                              'filter[status]': 'all',
                              'filter[user_id]': scope.row.owner.id,
                            },
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_92
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_93, [
                            _createElementVNode("table", _hoisted_94, [
                              _createElementVNode("tr", null, [
                                _hoisted_95,
                                _createElementVNode("td", _hoisted_96, [
                                  (
                                  scope.row.owner &&
                                    scope.row.owner.stats &&
                                    scope.row.owner.stats.ads
                                )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(scope.row.owner.stats.ads.active), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_98,
                                _createElementVNode("td", _hoisted_99, [
                                  (
                                  scope.row.owner &&
                                    scope.row.owner.stats &&
                                    scope.row.owner.stats.ads
                                )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(scope.row.owner.stats.ads.rejected), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 align-top",
                width: _ctx.calcWidth(460),
                label: "Модерация"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог одобрений ${
                        scope.row.approved_log
                          ? scope.row.approved_log.count
                          : '0'
                      }`
                    ,
                          name: "1"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              (
                          scope.row.approved_log && scope.row.approved_log.count
                        )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    (
                            scope.row.approved_log.log &&
                              scope.row.approved_log.log.length
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                          _hoisted_103,
                                          _createVNode(_component_el_timeline, null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approved_log
                                .log, (reason, index) => {
                                                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                  key: index,
                                                  timestamp: reason.date
                                                }, {
                                                  default: _withCtx(() => [
                                                    (reason.moderator.id)
                                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                                          key: 0,
                                                          class: "underline text-success",
                                                          to: {
                                  name: 'users-edit',
                                  params: {
                                    id: reason.moderator.id,
                                  },
                                }
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (
                                    reason.moderator.name &&
                                      reason.moderator.name.length
                                  )
                                                              ? (_openBlock(), _createElementBlock("strong", _hoisted_104, _toDisplayString(reason.moderator.name), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_105, " Нет имени "))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["to"]))
                                                      : (
                                  reason.moderator.name &&
                                    reason.moderator.name.length
                                )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(reason.moderator.name), 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_107, " Нет имени "))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["timestamp"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_108, _hoisted_110))
                            ])), [
                              [_directive_loading, scope.row.logApprovedProgress]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог отклонений ${
                        scope.row.rejected_log
                          ? scope.row.rejected_log.count
                          : '0'
                      }`
                    ,
                          name: "2"
                        }, {
                          default: _withCtx(() => [
                            (
                        scope.row.rejected_log && scope.row.rejected_log.count
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                  _createElementVNode("p", null, " Отклонено раз: " + _toDisplayString(scope.row.rejected_log.count), 1),
                                  (
                          scope.row.rejected_log.log &&
                            scope.row.rejected_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                        _hoisted_113,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.rejected_log
                              .log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_114, _toDisplayString(reason.text), 1),
                                                  (reason.moderator.id)
                                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 0,
                                                        class: "underline text-success",
                                                        to: {
                                name: 'users-edit',
                                params: {
                                  id: reason.moderator.id,
                                },
                              }
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (
                                  reason.moderator.name &&
                                    reason.moderator.name.length
                                )
                                                            ? (_openBlock(), _createElementBlock("strong", _hoisted_115, _toDisplayString(reason.moderator.name), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_116, " Нет имени "))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["to"]))
                                                    : (
                                reason.moderator.name &&
                                  reason.moderator.name.length
                              )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(reason.moderator.name), 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_118, " Нет имени "))
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_119, _hoisted_121))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    _createElementVNode("div", _hoisted_122, [
                      _createVNode(_component_el_checkbox_group, {
                        class: "my-2",
                        size: "small",
                        modelValue: scope.row.reasons,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.reasons) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reasonItem, reasonIndex) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: reasonIndex,
                              label: reasonItem,
                              class: "mb-4",
                              onChange: ($event: any) => (_ctx.checkItemOnReasonSelect(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reasonItem.value.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "onChange"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(140),
                label: "Категория"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.rubric && scope.row.rubric.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_123, _toDisplayString(scope.row.rubric.name), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170),
                label: "Юзер"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.owner && scope.row.owner.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_124, [
                          _createElementVNode("strong", null, _toDisplayString(scope.row.owner.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.owner && scope.row.owner.account_pro)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_125, _hoisted_128))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_129, _toDisplayString(scope.row.updated_at), 1),
                    (scope.row.author)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_130, _toDisplayString(scope.row.author.name), 1))
                      : _createCommentVNode("", true),
                    (scope.row.owner && scope.row.owner.registered_at)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_131, [
                          _hoisted_132,
                          _hoisted_133,
                          _createElementVNode("span", null, _toDisplayString(scope.row.owner.registered_at), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortTheColumn('created_at')))
                    }, [
                      _hoisted_135,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState['created_at'].dir,
                      'bi-sort-down': !_ctx.sortState['created_at'].dir,
                      'opacity-25':
                        _ctx.currentSort !== 'created_at' &&
                        _ctx.currentSort !== '-created_at',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_136, _toDisplayString(scope.row.created_at), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortTheColumn('modified_at')))
                    }, [
                      _hoisted_138,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState['modified_at'].dir,
                      'bi-sort-down': !_ctx.sortState['modified_at'].dir,
                      'opacity-25':
                        _ctx.currentSort !== 'modified_at' &&
                        _ctx.currentSort !== '-modified_at',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.modified_at && scope.row.modified_at.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_139, _toDisplayString(scope.row.modified_at), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_140, " Нет "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(220)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTheColumn('price')))
                    }, [
                      _hoisted_142,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState.price.dir,
                      'bi-sort-down': !_ctx.sortState.price.dir,
                      'opacity-25':
                        _ctx.currentSort !== 'price' && _ctx.currentSort !== '-price',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-center", _ctx.rowClasses])
                  }, [
                    _createVNode(_component_AgroPriceText, {
                      modelValue: scope.row.price,
                      measureName: scope.row.measure_name
                    }, null, 8, ["modelValue", "measureName"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _hoisted_143
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (
                    scope.row.country_of_origin &&
                      scope.row.country_of_origin.length
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_144, _toDisplayString(scope.row.country_of_origin), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_145, " Пусто "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(180)
              }, {
                header: _withCtx(() => [
                  _hoisted_146
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.geo_name && scope.row.geo_name.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_147, _toDisplayString(scope.row.geo_name), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_148, " Пусто "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                width: _ctx.calcWidth(60)
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createVNode(_component_el_button_group, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Одобрить",
                          onClick: ($event: any) => (_ctx.allowEntry(scope.row))
                        }, _hoisted_151, 8, _hoisted_149),
                        _createElementVNode("button", _hoisted_152, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'ads-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_153
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Удалить",
                          onClick: ($event: any) => (_ctx.deleteEntry(scope.row))
                        }, _hoisted_156, 8, _hoisted_154)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.adsLoading]
          ]),
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                _createVNode(_component_el_button, {
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.allowBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_158
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "warning",
                  title: _ctx.declineButtonTitle,
                  disabled: _ctx.bulkDeclineStatus,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rejectBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_159
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_160
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Активировать премиум'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openPremiumDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_161
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onFilterButtonClick", "items-total", "pages-total", "current-page"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.premiumDialogVisible,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.premiumDialogVisible) = $event)),
        title: "Активация премиум",
        width: "480px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.premiumDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_163
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.premiumSubmitting,
            disabled: !_ctx.premiumDateFrom || !_ctx.premiumDateTo,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirmActivatePremium()))
          }, {
            default: _withCtx(() => [
              _hoisted_164
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        default: _withCtx(() => [
          (_ctx.premiumModalError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.premiumModalError), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form, { "label-position": "top" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Период" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.premiumPeriod,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.premiumPeriod) = $event)),
                    style: {"width":"100%"},
                    onChange: _ctx.recalcPremiumDateTo
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "1 день",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "7 дней",
                        value: 7
                      }),
                      _createVNode(_component_el_option, {
                        label: "30 дней",
                        value: 30
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Активация услуги от" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.premiumDateFrom,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.premiumDateFrom) = $event)),
                    type: "datetime",
                    format: _ctx.localDateTimeFormat,
                    style: {"width":"100%"},
                    onChange: _ctx.recalcPremiumDateTo
                  }, null, 8, ["modelValue", "format", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Активация услуги до" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.premiumDateTo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.premiumDateTo) = $event)),
                    type: "datetime",
                    format: _ctx.localDateTimeFormat,
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "format"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}